import { BaseModel } from '@tcc-mono/shared/data-access';

export class Color extends BaseModel {
  id: number;
  code: string;
  name: string;
}
